import { resolveCssVariable, theme } from '@prophecy/ui';
import ProphecyIcon from '@prophecy/ui-v3/assets/images/Logos/logo-prophecy.svg?inline';

import { useUser } from '../context/user';
import { INKEEP_API_KEY } from './secrets';

const useInkeepSettings = (userAvatar?: string) => {
  const {
    user: { email, id, firstName, lastName }
  } = useUser();

  const baseSettings = {
    apiKey: INKEEP_API_KEY,
    // integrationId: INKEEP_INTEGRATION_ID,
    // organizationId: INKEEP_ORGANIZATION_ID,
    primaryBrandColor: resolveCssVariable(theme.colors.brand600),
    organizationDisplayName: 'Prophecy.io',
    env: 'production',

    userProperties: {
      id,
      email,
      name: (firstName?.toUpperCase() || '') + ' ' + (lastName?.toUpperCase() || '')
    }
    // ...optional settings
  };

  const modalSettings = {
    // optional settings
  };

  const searchSettings = {
    // optional settings
  };

  const aiChatSettings = {
    // optional settings
    chatSubjectName: 'Prophecy',
    aiAssistantAvatar: ProphecyIcon,
    shouldOpenLinksInNewTab: true,
    userAvatar: userAvatar,
    getHelpOptions: [
      {
        name: 'Help',
        action: {
          type: 'open_link',
          url: 'https://docs.prophecy.ai/data-engineering/administration/getting-help/get-in-touch'
        },
        icon: {
          builtIn: 'IoHelpBuoyOutline'
        }
      },
      {
        name: 'Slack',
        action: {
          type: 'open_link',
          url: 'https://prophecy-io-support.slack.com'
        },
        icon: {
          builtIn: 'FaSlack'
        }
      },
      {
        name: 'Customer Support Portal',
        action: {
          type: 'open_link',
          url: 'https://prophecy.zendesk.com'
        },
        icon: {
          builtIn: 'IoHelpBuoyOutline'
        }
      }
    ],
    exampleQuestions: [
      'How to connect Prophecy and Snowflake?',
      'Which datasets are accessible to Prophecy Data Copilot?',
      'How to monitor pipelines?',
      'How to create a Kafka Source gem?'
    ]
  };

  return { baseSettings, aiChatSettings, searchSettings, modalSettings };
};

export default useInkeepSettings;
